<h1 class="text-center" mat-dialog-title>
  <span class="d-block text-uppercase">sms</span>
  <span class="font-weight-bold">{{'verification' | translate}}</span>
  <span (click)="onCloseConfirm()" [inlineSVG]="'assets/img/times1.svg'"
        class="svg-15 d-flex align-items-center justify-content-center"></span>
</h1>
<div mat-dialog-content>
  <form [formGroup]="formGroup">
    <div *ngIf="data.type == 1" class="form-group">
      <input [(ngModel)]="code" [class.is-invalid]="result.statusMessage" [maxLength]="4" autocomplete="new-password"
             class="standard-input"
             formControlName="code"
             [placeholder]="'enter-4-digit-code' | translate" type="text">
      <mat-error *ngIf="result.statusMessage">{{ result.statusMessage }}</mat-error>
    </div>
    <div *ngIf="data.type == 2" class="form-group">
      <input *ngIf="data.type == 2" [(ngModel)]="phone" autocomplete="new-password" class="standard-input"
             formControlName="phone"
             maxlength="12" [placeholder]="'mobile-number' | translate" type="tel">
      <mat-error *ngIf="result.statusMessage">{{ result.statusMessage }}</mat-error>
    </div>
  </form>
</div>
<div>
  <div *ngIf="data.type == 1" class="form-group">
    <button (click)="registerUser(buttonForGtag)" [disabled]="!isValid('code') || registerInProgress" >{{'approve' | translate}}</button>
  </div>
  <div *ngIf="data.type == 1" class="form-group">
    <button class="resend-button" (click)="sendCode()" [disabled]="!isValid('phone') || !resendAvailable">
      {{'resend' | translate}}
      <span *ngIf="!resendAvailable">({{timeLeft | time: true}})</span>
    </button>
  </div>

  <button #buttonForGtag id="customer-registration-completed" style="display: none !important">
  </button>
  <!--    <a *ngIf="doctor.type == 1" (click)="resend()">გაგზავნა</a>-->
</div>
